module.exports = __webpack_public_path__ + "static/img/16.dfcb781.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/16.png
// module id = mllB
// module chunks = 0